import React from "react";
import { Row } from "react-foundation";
import errorIcon from "./../images/error-triangle-icon.svg";
import "css/InputError.css";

const InputError = ({ input, metas }) => {
    metas = metas || [];

    if (!Array.isArray(metas)) {
        metas = [metas];
    }

    if (input) {
        metas.push(input.meta);
    }

    metas = metas.filter(meta => meta.error && meta.touched);

    if (metas.length === 0) return null;

    return (
        <Row isColumn>
            <div className="InputError">
                <img src={errorIcon} alt="" />
                <div className="error-text">
                    {metas.map((meta, index) => {
                        // test
                        return <span key={index}>{meta.error}</span>;
                    })}
                </div>
            </div>
        </Row>
    );
};

export default InputError;



// WEBPACK FOOTER //
// ./src/components/InputError.js